import React, { useState,useEffect  } from 'react';
import "./Sidebar.css";
import {setCookie, getCookie, cookieExists, deleteCookie} from "../../Script/cookies.js";
import ContactMailIcon from '@mui/icons-material/ContactMail';
import SwitchAccountOutlinedIcon from '@mui/icons-material/SwitchAccountOutlined';
import { post } from '../../Script/Session.js';
import { Token } from '../../Script/Session.js';
import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined';
import Sidebarperson from './components/Sidebarperson.jsx';
import { useNavigate } from 'react-router-dom';
const Sidebar = () => {
    const [visible,setvisible] = useState("-200px");
 
    let [data, setdata] = useState([]);
    const navigate = useNavigate();
    let id = null;
    useEffect(() => {
        getdata();

        function getdata() {
            updatedata();
            
        }



        const handleMouseMove = (event) => {
          if (window.innerWidth >= 1200){
            const windowWidth = window.innerWidth;
            const cursorX = event.clientX;
      
  
            const boundary = windowWidth * 0.85;
      
  
             if (cursorX >= boundary) {
              setvisible("-9px"); 
            } else {
              setvisible("-200px"); 

            } 
          } 
        };
    
        // Add event listener for mouse move
        window.addEventListener('mousemove', handleMouseMove);
        id = setInterval(getdata, 3 * 60 * 1000);
        // Cleanup the event listener on component unmount
        return () => {
          clearInterval(id);
          window.removeEventListener('mousemove', handleMouseMove);
        };
      }, []);
      function updatedata(){
        let body = {};
        body.token = Token.get();
        let response = post(body, "/onlineuser");
        if (response == null){
          navigate("/");
          clearInterval(id);
          return;
        }
        if (response == "LOGOUT"){
          navigate("/");
          clearInterval(id);
          return;
        }
        try {
          setdata(JSON.parse(response));
        }catch (e){
          navigate("/");
          clearInterval(id);
        }
        
      }
      
    return (
        <div className="sidebar" style={{right : visible}} >
            <div className="useronlinebar-headericon">
              <AccountCircleOutlined sx={{ fontSize: "2vw" }} className='useronlinebar-header-icon'/>
            </div>
            <div className='useronlinebar-placeline'></div>
            <ul style={{listStyleType : "none", paddingLeft : "0"}}>
            {data.length > 0 ? (
            data.map((item, index) => (
            <li  ><Sidebarperson key={index} data={item} extended={visible} /></li>
            ))
            ) : (
            <p>Loading...</p> // Show loading text until data is fetched
            )}
            </ul>

      

      </div>
    );



}
export default Sidebar;
